import { useState, useEffect } from "react";
import axios from "axios";
import "./AssistantPage.css";


const AssistantPage = ({setSelectedAssistant, setSelectedAssistantId}) => {
  const [name, setName] = useState("");
  const [assistants, setAssistants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // Fetch assistants for the logged-in user
  const fetchAssistants = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/assistant/`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('accessToken')}`
        }
      });
      setAssistants(response.data);
      setSelectedAssistant(response.data[0].name);
      setSelectedAssistantId(response.data[0].id);
      setLoading(false);
    } catch (err) {
      setError("Failed to fetch assistants.");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAssistants();
  }, []);

  // Create a new assistant
  const handleCreate = async (e) => {
    e.preventDefault();
    if (!name) return;

    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/assistant/`, { name }, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('accessToken')}`
        }
      });
      setAssistants([...assistants, response.data]);
      setName(""); // Clear input
    } catch (err) {
      setError("Failed to create assistant.");
    }
  };

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4">My Assistants</h1>

      {/* Form to create new assistant */}
      {/* <form onSubmit={handleCreate} className="mb-6">
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Assistant Name"
          className="border p-2 rounded mr-2"
        />
        <button type="submit" className="bg-blue-500 text-white p-2 rounded">
          Create
        </button>
      </form> */}

      {/* {error && <p className="text-red-500 mb-4">{error}</p>} */}

      {/* Display assistants */}
      {loading ? (
        <p>Loading...</p>
      ) : assistants.length === 0 ? (
        <p>No assistants found.</p>
      ) : (
        <ul>
          {assistants.map((assistant) => (
            <li onClick={() => {
              setSelectedAssistant(assistant.name);
              setSelectedAssistantId(assistant.id);
            }} key={assistant.id} className="mb-2 border p-2 rounded">
              {assistant.name || "Unnamed Assistant"}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AssistantPage;
